import { Component, OnInit,NgZone, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-add-geolocation',
  templateUrl: './add-geolocation.component.html',
  styleUrls: ['./add-geolocation.component.css']
})
export class AddGeoLocationComponent implements OnInit {
  // @Output() geofenceRadius: any = new EventEmitter();
  // @Input() geofenceRadius:number;
  public geofenceRadius:number=1;
  @ViewChild('modalHide') modalHide;
  
  public addBranchForm:FormGroup;
  public addBranchFormSubmitted:boolean=false;
  public branchLocation={};
  public selectedValueClose = false;
  public locationSuggestions={};
  public getDefaultBranch:any='';
  public radiusCnt :number = 1
  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'branchLocation';
  formSubmit:boolean=false;
  public selectedMap:string='osrm';
  public disableLocation:boolean=true;
  
  //geofence
  public isMultipleGeo:boolean=false;

  //radius error
  public isRadiusGreater:boolean=false;
  public radiusError:string='';
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public ngZone:NgZone,) 
    { 
      let user = this.storage.get('userInfo');
      if(user && user.map){
        this.selectedMap = user.map;
      }
    }

  ngOnInit(): void {
    this.addBranchLoad();
    if(this.selectedMap=='google'){
      setTimeout(()=>{
        let radius=document.getElementById("radius");
        if(radius!=null){
            radius.addEventListener("keypress", function (evt) {
              if(evt.key=='-' || evt.key==' ' || evt.key=='+'){
                evt.preventDefault();
              }
            });
          }
        },100)
    }
  }
  addBranchLoad(){
    this.addBranchForm = new FormGroup({
      branchName: new FormControl('', [Validators.required,Validators.pattern(/^([A-Za-z0-9 ])+(?:\.[a-zA-Z0-9]+?)*$/)]),
      radius: new FormControl(this.radiusCnt, [Validators.required]),
      location: new FormControl('', [Validators.required]),
    });
  }
  formatName(){
    let branchName=this.addBranchForm.value.branchName.replace(/ {2,}/g,' ').trim();
    this.addBranchForm.patchValue({
      branchName:branchName
    })
  }
   /* checking error in fields*/

   public checkError = (controlName: string, errorName: string) => {
    return this.addBranchForm.controls[controlName].hasError(errorName);
  }
  radiusValidation(){
    this.geofenceRadius=this.addBranchForm.value.radius;
    let radiusField=document.getElementById('radiusField');
    if(this.addBranchForm.value.radius<=25 && this.addBranchForm.value.radius>0 && this.addBranchForm.value.radius!=null){
      this.isRadiusGreater=false;
      radiusField.classList.remove('mat-form-field-invalid');
      radiusField.classList.remove('ng-invalid');
      radiusField.classList.add('ng-valid');
      this.radiusError='';
    }else if(this.addBranchForm.value.radius==null){
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.isRadiusGreater=false;
      this.radiusError='';
    }else if(this.addBranchForm.value.radius==0){
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError='Radius must be above 0KM';
      this.isRadiusGreater=true;
    }else{
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError='Radius limits upto 25KM';
      this.isRadiusGreater=true;
    }
  }

  getLocation(obj){
    this.branchLocation = {...obj};
  }
  /* Cancel Add branch*/

  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/view-branch']);
  }

  // Default Branch
  defaultBranch(e:any){
    this.getDefaultBranch= e.checked
  }
  getSelectedLocation(obj){
    this.branchLocation={...obj};
    if(this.branchLocation && this.branchLocation['name'] && this.branchLocation['name']!=''){
      this.addBranchForm.patchValue({
        location : this.branchLocation['name']
      })
    }
  }
  /* submit data*/
  onSubmit(){
    this.formSubmit = true;
    this.addBranchFormSubmitted = true;
    // if(this.selectedMap=='google'){
    //   this.radiusValidation();
    // }
    if (this.addBranchForm.valid && this.selectedMap!='google' || this.addBranchForm.valid && this.selectedMap=='google' && !this.isRadiusGreater) {
      const obj = {
        isDefault:this.getDefaultBranch,
        orgID: this.storage.get('userInfo').orgID,
        ...this.addBranchForm.value
      };

      delete obj.location;
      obj.location=this.branchLocation;
      this.api.transportManagerBranchCreate(obj).then((res: any) => {
        if (res.status == 'success') {

          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/view-branch'])

        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });

    }
  }

}
